import { Instagram, Facebook, Music2 } from "lucide-react";
import { SOCIALS, CONTACT } from "../lib/contact";

const iconMap = { Instagram, Facebook, TikTok: Music2 };

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#eeede9] border-t border-black/15 pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-6">
            <div className="text-4xl tracking-tight leading-none flex items-baseline">
              <span className="font-editorial text-[#ca0013]">Vertex</span>
              <span className="font-display text-[#ca0013] pl-2 lowercase" style={{ fontWeight: 800 }}>
                house
              </span>
            </div>
            <p className="font-body text-[#4a4a4a] mt-4 max-w-md leading-relaxed">
              Agencia de marketing digital. Estrategia, contenido y diseño
              para marcas que quieren crecer con intención.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-label text-xs text-[#4a4a4a] mb-4">
              Contacto
            </div>
            <a
              href={`tel:${CONTACT.phoneRaw}`}
              data-testid="footer-phone"
              className="block font-body text-[#111] hover:text-[#ca0013] transition-colors"
            >
              {CONTACT.phone}
            </a>
            <a
              href={`mailto:${CONTACT.email}`}
              data-testid="footer-email"
              className="block font-body text-[#111] hover:text-[#ca0013] transition-colors mt-2 break-all"
            >
              {CONTACT.email}
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="font-label text-xs text-[#4a4a4a] mb-4">Redes</div>
            <div className="flex items-center gap-3">
              {SOCIALS.map((s) => {
                const Icon = iconMap[s.name];
                return (
                  <a
                    key={s.name}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-social-${s.name.toLowerCase()}`}
                    aria-label={s.name}
                    className="w-10 h-10 rounded-full border border-black/20 flex items-center justify-center hover:bg-[#ca0013] hover:text-white hover:border-[#ca0013] transition-colors"
                  >
                    <Icon size={16} />
                  </a>
                );
              })}
            </div>
            <p className="font-editorial text-[#4a4a4a] mt-4 text-sm">
              {CONTACT.handle}
            </p>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-black/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-body text-xs text-[#4a4a4a]">
            © {new Date().getFullYear()} Vertex House. Todos los derechos
            reservados.
          </p>
          <p className="font-editorial text-sm text-[#4a4a4a]">
            Construimos marcas que la gente recuerda.
          </p>
        </div>
      </div>
    </footer>
  );
};
